import { render, staticRenderFns } from "./PopularMasterSetting.vue?vue&type=template&id=583e43cc"
import script from "./PopularMasterSetting.vue?vue&type=script&lang=js"
export * from "./PopularMasterSetting.vue?vue&type=script&lang=js"
import style0 from "./PopularMasterSetting.vue?vue&type=style&index=0&id=583e43cc&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports